<template>
  <button type="click" @click.prevent="logout">Logout</button>
</template>

<script>
export default {
  name: "Logout",
  methods: {
    async logout() {
      await this.axios.post("/auth/logout");
    }
  }
};
</script>

<style scoped></style>
